import React from "react";
import styles from './styles.css'
import bitmoji from './bitmoji.png'

import Container from '../../../components/Container'
import Title from '../../../components/Title'

export default () => {
  return (
    <div>
      <Title direction='left'>OH, HAII!!</Title>
      <Container align='center'>
        <img src={bitmoji} alt="Bitmoji" />
        <h1 className="name">my name is <span>Matt Patterson.</span></h1>
        <p>Music lover, gig attender and heavy coffee drinker. Oh, and I write software sometimes too.</p>
      </Container>
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/parts/home/About/index.js